import AddToCart from '../AddToCart';
import BookCarousel from '../BookCarousel';


export default function BookPage() {

  document.title = `Fan Mail, Frank Letters and Crank Calls by Cookie Mueller | Hanuman Editions`;
  document.querySelector('meta[name="description"]').setAttribute('content', `Following the publication of Cookie Mueller’s Garden of Ashes in our first series, we are thrilled to reissue her first contribution to the Hanuman canon: Fan Mail, Frank Letters, and Crank Calls.`);

  return (<div className='newPageContainer'>
    <div className='productContainer'>
      <div className='productImage_container  '>
        <div className='productCarousel'>
          <BookCarousel images={['../../Series-Two/Fanmail_Back.png', '../../Series-Two/Fanmail_Side.png', '../../Series-Two/Fanmail_Front.png']} start={1} />
        </div>
      </div>
      <div className='productInfo_container'>
        <div className='productInfo_inner'>
          <div className='productInfo'>
            <h1 className='productTitle'>Fan Mail, Frank Letters and Crank Calls</h1>
            <div className='productAuthor'>Cookie Mueller</div>
          </div>
          <div className='productBuyControls'>
            <AddToCart context={'product'} id={'9798989378081'} />
            <div className='productPrice'>$15.99 USD</div>
          </div>
          <div className='productExcerpt'>
            <p><em>
              “Hello?”<br></br>
              “Yeah, hi Georgia!”<br></br>
              “This isn’t Georgia. Who’s<br></br>
              calling please?”<br></br>
              “John Huston.”<br></br>
              “From the grave ?”<br></br>
            </em></p>

          </div>

          <div className='productDescription'>
            In Cookie Mueller’s <em>Fan Mail, Frank Letters and Crank Calls</em>, one man’s obsession with a Hollywood starlet kicks off a chain of international correspondence that sends his extended family into a fantastical tailspin. Transpiring across then-emerging channels of networked communication, Mueller’s prescient story, from 1988, rides the chemtrails of microcelebrity ideation with sensitivity and wit.
          </div>
          <div className='productDescription'>
            <p>Writer, actress, underground It Girl and overall cult figure <strong>Cookie Mueller</strong> (1949–1989) is among the most beloved authors originally published by Hanuman Books. Radical in spirit and exactingly composed, Mueller’s work has had a significant cultural comeback in recent years through new collections and literary portraits. Mueller was famously immortalized on screen as a member of the film director John Waters' Dreamlanders, whose poignant oral histories suffuse her texts with sensitivity and gravitas.</p>
          </div>
          <div className='productMetadata'>
            <div>Series II</div>
            <div>Spring 2026</div>
            <div>ISBN 979-8-9893780-8-1</div>
            <div>4.125 x 2.75 inches</div>
            <div>104 Pages</div>
          </div>
        </div>
      </div>
    </div>
  </div>)

}